import store from './module/store'
import routes from './module/routes'

export default {
	name: 'checkin-facility',
	store: store,
	routes: routes
}